import { useState } from "react";
import { useNavigate } from "react-router-dom";
import YildizArkaplan from "../components/YildizArkaplan";
import { useTranslation } from "react-i18next";
import i18n from "../i18n/i18n";

const DILLER = [
  { kod: "tr", isim: "Türkçe", bayrak: "🇹🇷" },
  // { kod: "en", isim: "English", bayrak: "🇬🇧" },
  // { kod: "de", isim: "Deutsch", bayrak: "🇩🇪" },
  // { kod: "fr", isim: "Français", bayrak: "🇫🇷" },
  // { kod: "ru", isim: "Русский", bayrak: "🇷🇺" },
  // { kod: "es", isim: "Español", bayrak: "🇪🇸" },
];

export default function Onboarding() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [aktif, setAktif] = useState(0); // 0 = dil seçimi, 1-4 = slaytlar
  const [bildirimIstendi, setBildirimIstendi] = useState(false);
  const [seciliDil, setSeciliDil] = useState(i18n.language || "tr");

  const SLIDES = [
    {
      emoji: "🔮",
      baslik: t("onboarding.slides.0.title"),
      aciklama: t("onboarding.slides.0.desc"),
      alt: t("onboarding.slides.0.alt"),
      renk: "#A855F7",
      bg: "radial-gradient(ellipse at center, rgba(168,85,247,0.25) 0%, transparent 70%)",
    },
    {
      emoji: "🧙",
      baslik: t("onboarding.slides.1.title"),
      aciklama: t("onboarding.slides.1.desc"),
      alt: t("onboarding.slides.1.alt"),
      renk: "#F472B6",
      bg: "radial-gradient(ellipse at center, rgba(244,114,182,0.2) 0%, transparent 70%)",
      falcilar: ["👵", "🌙", "🧔", "✨", "👩", "🧳"],
    },
    {
      emoji: "🔔",
      baslik: t("onboarding.slides.2.title"),
      aciklama: t("onboarding.slides.2.desc"),
      alt: t("onboarding.slides.2.alt"),
      renk: "#F9CB42",
      bg: "radial-gradient(ellipse at center, rgba(249,203,66,0.15) 0%, transparent 70%)",
      bildirim: true,
    },
    {
      emoji: "🎁",
      baslik: t("onboarding.slides.3.title"),
      aciklama: t("onboarding.slides.3.desc"),
      alt: t("onboarding.slides.3.alt"),
      renk: "#34D399",
      bg: "radial-gradient(ellipse at center, rgba(52,211,153,0.15) 0%, transparent 70%)",
      sonEkran: true,
    },
  ];

  const dilSecimEkrani = aktif === 0;
  const slideIndex = aktif - 1;
  const slide = dilSecimEkrani ? null : SLIDES[slideIndex];
  const sonSlide = aktif === SLIDES.length;

  const dilSec = (kod) => {
    setSeciliDil(kod);
    i18n.changeLanguage(kod);
    localStorage.setItem("remil-lang", kod);
  };

  const bildirimIzniAl = async () => {
    if ("Notification" in window) await Notification.requestPermission();
    setBildirimIstendi(true);
    sonraki();
  };

  const sonraki = () => {
    if (sonSlide) return;
    setAktif((prev) => prev + 1);
  };

  const atla = () => navigate("/giris");

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
      position: "relative", fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420, margin: "0 auto",
      display: "flex", flexDirection: "column", overflow: "hidden",
    }}>
      <style>{`
        @keyframes yukari-gel { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes donuyor { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes titreme { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.15); } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
      `}</style>

      <YildizArkaplan />

      {/* Arkaplan ışığı */}
      <div style={{
        position: "absolute", top: "20%", left: "50%", transform: "translateX(-50%)",
        width: 400, height: 400, borderRadius: "50%",
        background: slide ? slide.bg : "radial-gradient(ellipse at center, rgba(168,85,247,0.2) 0%, transparent 70%)",
        pointerEvents: "none", transition: "background 0.6s ease",
      }} />

      {/* Atla butonu */}
      <div style={{ position: "relative", zIndex: 2, padding: "52px 24px 0", display: "flex", justifyContent: "flex-end" }}>
        {!sonSlide && (
          <button onClick={atla} style={{
            background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)",
            borderRadius: 20, padding: "6px 16px",
            color: "rgba(255,255,255,0.5)", fontSize: 13, cursor: "pointer",
          }}>
            {t("onboarding.skip")}
          </button>
        )}
      </div>

      {/* DİL SEÇİM EKRANI */}
      {dilSecimEkrani && (
        <div style={{
          position: "relative", zIndex: 2, flex: 1,
          display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center",
          padding: "20px 32px",
          animation: "yukari-gel 0.5s ease backwards",
        }}>
          <div style={{ fontSize: 56, marginBottom: 20 }}>🌍</div>
          <div style={{
            fontSize: 24, fontWeight: 800, color: "#fff",
            fontFamily: "Georgia, serif", textAlign: "center", marginBottom: 8,
          }}>
            Choose your language
          </div>
          <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", marginBottom: 32, textAlign: "center" }}>
            Dilinizi seçin / Select your language
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 10, width: "100%" }}>
            {DILLER.map((dil) => (
              <button
                key={dil.kod}
                onClick={() => dilSec(dil.kod)}
                style={{
                  width: "100%", padding: "14px 20px", borderRadius: 14,
                  background: seciliDil === dil.kod ? "rgba(168,85,247,0.3)" : "rgba(255,255,255,0.06)",
                  border: seciliDil === dil.kod ? "1px solid rgba(168,85,247,0.6)" : "1px solid rgba(255,255,255,0.1)",
                  color: seciliDil === dil.kod ? "#fff" : "rgba(255,255,255,0.6)",
                  fontSize: 15, fontWeight: seciliDil === dil.kod ? 700 : 500,
                  cursor: "pointer", display: "flex", alignItems: "center", gap: 12,
                  transition: "all 0.2s",
                }}
              >
                <span style={{ fontSize: 24 }}>{dil.bayrak}</span>
                <span>{dil.isim}</span>
                {seciliDil === dil.kod && <span style={{ marginLeft: "auto", color: "#C084FC" }}>✓</span>}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* SLAYTLAR */}
      {!dilSecimEkrani && slide && (
        <div style={{
          position: "relative", zIndex: 2, flex: 1,
          display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center",
          padding: "20px 32px",
          animation: "yukari-gel 0.5s ease backwards",
        }}>
          <div style={{
            fontSize: 80, marginBottom: 24,
            animation: slideIndex === 0 ? "donuyor 20s linear infinite" : "titreme 3s ease-in-out infinite",
            display: "inline-block",
            filter: `drop-shadow(0 0 30px ${slide.renk}88)`,
          }}>
            {slide.emoji}
          </div>

          {slide.falcilar && (
            <div style={{ display: "flex", gap: 12, marginBottom: 24 }}>
              {slide.falcilar.map((emoji, i) => (
                <div key={i} style={{
                  width: 44, height: 44, borderRadius: 14,
                  background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.12)",
                  display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22,
                  animation: `yukari-gel 0.4s ease ${i * 0.08}s backwards`,
                }}>{emoji}</div>
              ))}
            </div>
          )}

          <div style={{
            fontSize: 28, fontWeight: 800, color: "#fff",
            fontFamily: "Georgia, serif", textAlign: "center", marginBottom: 16, lineHeight: 1.2,
            textShadow: `0 0 40px ${slide.renk}66`,
          }}>
            {slide.baslik}
          </div>

          <div style={{ fontSize: 15, color: "rgba(255,255,255,0.65)", textAlign: "center", lineHeight: 1.7, marginBottom: 12 }}>
            {slide.aciklama}
          </div>

          <div style={{ fontSize: 12, color: slide.renk, textAlign: "center", fontWeight: 600, letterSpacing: 0.5, opacity: 0.8 }}>
            ✦ {slide.alt}
          </div>

          {slide.sonEkran && (
            <div style={{
              marginTop: 24, background: "rgba(52,211,153,0.1)",
              border: "1px solid rgba(52,211,153,0.3)", borderRadius: 20, padding: "14px 28px",
              fontSize: 32, color: "#34D399", fontWeight: 800,
              display: "flex", alignItems: "center", gap: 10,
            }}>
              <span>🪙</span>
              <span>50 Token</span>
              <span style={{ fontSize: 14, color: "rgba(52,211,153,0.7)" }}>hediye!</span>
            </div>
          )}
        </div>
      )}

      {/* Alt Kısım */}
      <div style={{
        position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)",
        width: "100%", maxWidth: 420, zIndex: 10, padding: "0 32px 48px",
        background: "linear-gradient(to top, #0a0718 60%, transparent)",
      }}>
        {/* Nokta göstergesi — sadece slaytlarda */}
        {!dilSecimEkrani && (
          <div style={{ display: "flex", justifyContent: "center", gap: 8, marginBottom: 28 }}>
            {SLIDES.map((_, i) => (
              <div key={i} onClick={() => setAktif(i + 1)} style={{
                width: i === slideIndex ? 24 : 8, height: 8, borderRadius: 4,
                background: i === slideIndex ? slide.renk : "rgba(255,255,255,0.2)",
                transition: "all 0.3s ease", cursor: "pointer",
              }} />
            ))}
          </div>
        )}

        {/* Dil seçimi devam butonu */}
        {dilSecimEkrani && (
          <button onClick={sonraki} style={{
            width: "100%", padding: "16px", borderRadius: 16,
            background: "linear-gradient(135deg, #7c3aed, #a855f7)",
            border: "none", color: "#fff", fontSize: 16, fontWeight: 800,
            cursor: "pointer", fontFamily: "Georgia, serif",
            boxShadow: "0 0 24px rgba(168,85,247,0.4)",
          }}>
            {t("onboarding.continue")}
          </button>
        )}

        {/* Bildirim butonu */}
        {!dilSecimEkrani && slide?.bildirim && !bildirimIstendi && (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <button onClick={bildirimIzniAl} style={{
              width: "100%", padding: "16px", borderRadius: 16,
              background: "linear-gradient(135deg, #F9CB42, #F97316)",
              border: "none", color: "#fff", fontSize: 16, fontWeight: 800,
              cursor: "pointer", fontFamily: "Georgia, serif",
              boxShadow: "0 0 24px rgba(249,203,66,0.4)",
            }}>
              {t("onboarding.allowNotifications")}
            </button>
            <button onClick={sonraki} style={{
              width: "100%", padding: "12px", borderRadius: 14,
              background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)",
              color: "rgba(255,255,255,0.4)", fontSize: 13, cursor: "pointer",
            }}>
              {t("onboarding.notNow")}
            </button>
          </div>
        )}

        {/* Son ekran */}
        {!dilSecimEkrani && slide?.sonEkran && (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <button onClick={() => navigate("/giris")} style={{
              width: "100%", padding: "18px", borderRadius: 16,
              background: "linear-gradient(135deg, #7c3aed, #a855f7, #c084fc)",
              border: "none", color: "#fff", fontSize: 16, fontWeight: 800,
              cursor: "pointer", fontFamily: "Georgia, serif",
              boxShadow: "0 0 28px rgba(168,85,247,0.5)", letterSpacing: 0.5,
            }}>
              {t("onboarding.registerBtn")}
            </button>
            <button onClick={() => navigate("/giris")} style={{
              width: "100%", padding: "14px", borderRadius: 14,
              background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.15)",
              color: "rgba(255,255,255,0.6)", fontSize: 14, fontWeight: 600, cursor: "pointer",
            }}>
              {t("onboarding.loginBtn")}
            </button>
          </div>
        )}

        {/* Normal devam butonu */}
        {!dilSecimEkrani && slide && !slide.bildirim && !slide.sonEkran && (
          <button onClick={sonraki} style={{
            width: "100%", padding: "16px", borderRadius: 16,
            background: `linear-gradient(135deg, ${slide.renk}cc, ${slide.renk})`,
            border: "none", color: "#fff", fontSize: 16, fontWeight: 800,
            cursor: "pointer", fontFamily: "Georgia, serif",
            boxShadow: `0 0 24px ${slide.renk}44`,
          }}>
            {t("onboarding.continue")}
          </button>
        )}
      </div>
    </div>
  );
}